var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFedEx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1539,
    height: 472,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f60",
    d: "M1145.5 455 1274 310.6l-128.5-144.4h135.6l63.6 70.1 61.2-70.1h130.9L1408.9 310l129.6 145h-136.1l-63-70.7-62.5 70.7zM1145.5 101.4H1000v64.8h145.5v97.5H1000v89.6h145.5V455H893.1V0h252.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#652c8f",
    fillRule: "evenodd",
    d: "M893.1 0v455H786.6v-29.5h-1.2c-19.4 28.9-51.3 46-86 46-80.6 0-139.2-65-148.4-140.4H340.2c0 33.6 28 61.9 60.5 61.9 28 0 38.6-5.9 52.6-25.9h103.5c-27.1 66.6-78.4 103.1-156.1 103.1-92.5 0-165-66.6-165-161.5 0-15.9 1.9-30.9 5.5-45H120.8V455H0V0h268.7v101.4H120.8v64.8h135.5v59.6c27-48 78.8-77.4 144.4-77.4 80.7 0 135.1 42.5 156.3 111.8 18.5-62.9 71.2-110.5 141.2-110.5 34.2 0 63.6 9.4 87.2 36.5h1.2V0zM458.3 265.1c-5.6-29.5-26.8-47.8-57.6-47.8-28 0-50.4 18.9-57.1 47.8zm325.2 45.8c0-40.8-17.5-80.1-61.5-80.1-42.5 0-63.7 39.3-63.7 80.1 0 38.2 24.4 74.8 63.7 74.8 42.9 0 61.5-36 61.5-74.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFedEx);
export default __webpack_public_path__ + "static/media/FedEx.bc7b01f71e4e76ac5732d018e6dbfb83.svg";
export { ForwardRef as ReactComponent };